export const afsprakenAnalyticsEvents = [
  'afspraakAangemaakt',
  'afspraakGewijzigd',
  'afspraakVerwijderd',
  'beeldbelAfspraakAangemaakt',
  'beeldbelAfspraakGewijzigd',
  'beeldbelAfspraakVerwijderd',
  'afsprakenGeexporteerd',
] as const;
